import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Box,
  Chip,
} from '@mui/material';
import moment from 'moment';
import {
  cambiarEstadoPresupuesto,
  cerrarTareasPres,
} from '../../actions/PresupuestosAction';
import { useStateValue } from '../../contexto/store';
import { useHistory } from 'react-router-dom';
import { RegistrarAccion } from '../../actions/AuditoriaAction';
import { obtenerPresupuestoPorId } from '../../actions/PresupuestosAction';
import DescriptionIcon from '@mui/icons-material/Description';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIcon from '@mui/icons-material/Assignment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
export default function TPresupuestos({ rows, termp, idUsu }) {
  //PARA EL DETALLE!!!!!
const [openDetalle, setOpenDetalle] = useState(false);
const [detallePresupuesto, setDetallePresupuesto] = useState(null);

  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [cierre, setCierre] = useState({
    PRESUPUESTO_ID: '',
    MOTIVODECIERRE: '',
  });
  const history = useHistory();
  const irAHistorialDeTareas = (presupuesto) => {
    if (
      idUsu === 'SPV' ||
      idUsu === 'CGV' ||
      idUsu === 'CPV' ||
      idUsu === 'AV' ||
      idUsu === 'EV'
    ) {
      presupuesto['TipoVisitante'] = 'Propietario';
    } else {
      presupuesto['TipoVisitante'] = 'Visitante';
    }
    history.push({ pathname: '/tareasPresupuesto', state: presupuesto });
  };
  const abrirDialogCerrar = (presupuestos) => {
    setOpenDialog(true);
    setCierre({
      PRESUPUESTO_ID: presupuestos.presupuestO_Id,
      MOTIVODECIERRE: cierre.MOTIVODECIERRE,
    });
  };
  const cerrarDialog = () => {
    setOpenDialog(false);
    setCierre({
      PRESUPUESTO_ID: '',
      MOTIVODECIERRE: '',
    });
  };
  const cierreHandleChange = (e) => {
    const { name, value } = e.target;
    setCierre((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
const verDetallePresupuesto = (id) => {
  obtenerPresupuestoPorId(id).then((response) => {
    if (response.status === 200) {
      setDetallePresupuesto(response.data);
      setOpenDetalle(true);
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'No se pudo cargar el detalle del presupuesto',
        },
      });
    }
  });
};


  const cerrarPresupuesto = (estado) => {
    if (cierre.MOTIVODECIERRE !== '') {
      let fecha = moment().format().toString().substr(0, 16) + ':00';
      setCierre({
        PRESUPUESTO_ID: cierre.PRESUPUESTO_ID,
        MOTIVODECIERRE: cierre.MOTIVODECIERRE,
      });
      const id = cierre.PRESUPUESTO_ID;
      const objetoModC = {
        COMPLETADO: fecha,
        MOTIVOCANCELACION: 'CIERRE DE PRESUPUESTO',
      };
      let objetoMod = {};
      if (estado === 'PERDIDO') {
        objetoMod = {
          CERRADOPERDIDO: fecha,
          MOTIVODECIERRE: cierre.MOTIVODECIERRE,
        };
      } else {
        objetoMod = {
          CERRADOGANADO: fecha,
          MOTIVODECIERRE: cierre.MOTIVODECIERRE,
        };
      }

      cambiarEstadoPresupuesto(id, objetoMod).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se cerro exitosamente el Presupuesto',
            },
          });
          cerrarTareasPres(id, objetoModC).then((response) => {
            if (response.status === 200) {
              dispatch({
                type: 'OPEN_SNACKBAR',
                openMensaje: {
                  open: true,
                  mensaje: 'Se cerraron todas las tareas del presupuesto',
                },
              });
            } else {
              dispatch({
                type: 'OPEN_SNACKBAR',
                openMensaje: {
                  open: true,
                  mensaje: 'Errores al intentar cerrar las tareas ',
                },
              });
            }
          });
          setCierre({
            PRESUPUESTO_ID: '',
            MOTIVODECIERRE: '',
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Modificacion',
            panel: 'Gestion de Presupuestos',
            tabla: 'PRESUPUESTOS',
            filaafectada: cierre.PRESUPUESTO_ID,
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
          cerrarDialog();
          window.location.reload();
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'DEBE AGREGAR UN MOTIVO DE CIERRE ',
        },
      });
    }
  };

  function searchingTermp(termp) {
    return function (x) {
      let nombre = '';
      if (x.cliente.nombre === null) {
        nombre = '';
      } else {
        nombre = x.cliente.nombre;
      }
      let apellido = '';
      if (x.cliente.apellido === null) {
        apellido = '';
      } else {
        apellido = x.cliente.apellido;
      }
      let totalpresupuesto = 0;
      if (x.totalpresupuesto === null) {
        totalpresupuesto = '';
      } else {
        totalpresupuesto = x.totalpresupuesto;
      }
      let fechacomprobante = '';
      if (x.fechacomprobante === null) {
        fechacomprobante = '';
      } else {
        fechacomprobante = x.fechacomprobante;
      }
      let usuarioasignado = '';
      if (x.usuarioasignado === null) {
        usuarioasignado = '';
      } else {
        usuarioasignado = x.usuarioasignado;
      }
      let numerocomprobante = '';
      if (x.numerocomprobante === null || x.numerocomprobante === undefined) {
        numerocomprobante = '';
      } else {
        numerocomprobante = x.numerocomprobante;
      }
      return (
        nombre.toLowerCase().includes(termp.toLowerCase()) ||
        apellido.toLowerCase().includes(termp.toLowerCase()) ||
        totalpresupuesto
          .toString()
          .toLowerCase()
          .includes(termp.toLowerCase()) ||
        fechacomprobante.toLowerCase().includes(termp.toLowerCase()) ||
        usuarioasignado.toLowerCase().includes(termp.toLowerCase()) ||
     numerocomprobante.toString().toLowerCase().includes(termp.toLowerCase()) ||
        !termp
      );
    };
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = (rows || []).filter(searchingTermp(termp));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Código
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Fecha
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Usuario
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Cliente
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Total
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((presupuesto) => (
                <TableRow
                  key={presupuesto.presupuestO_Id}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <TableCell>
                    <Chip
                      label={presupuesto.numerocomprobante}
                      size="small"
                      color="primary"
                      variant="outlined"
                      icon={<DescriptionIcon />}
                      sx={{ fontWeight: 600 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <CalendarTodayIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      <Typography variant="body2" fontFamily="monospace">
                        {presupuesto.fechacomprobante.substr(-20, 10)}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      <Typography variant="body2" fontWeight={500}>
                        {presupuesto.usuarioasignado}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {presupuesto.cliente.nombre + ' ' + presupuesto.cliente.apellido}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600} color="success.main">
                      {Intl.NumberFormat('es').format(presupuesto.totalpresupuesto)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<AssignmentIcon />}
                        onClick={() => irAHistorialDeTareas(presupuesto)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          px: 1.5,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Tareas
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<VisibilityIcon />}
                        onClick={() => verDetallePresupuesto(presupuesto.presupuestO_Id)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          px: 1.5,
                          '&:hover': {
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Ver detalle
                      </Button>
                      {/* {idUsu === 'SPV' && (
                        <Button
                          variant="contained"
                          size="small"
                          color="error"
                          startIcon={<CloseIcon />}
                          onClick={() => abrirDialogCerrar(presupuesto)}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            px: 1.5,
                            boxShadow: 1,
                            '&:hover': {
                              boxShadow: 3,
                              transform: 'translateY(-1px)',
                            },
                            transition: 'all 0.2s ease',
                          }}
                        >
                          Cerrar
                        </Button>
                      )} */}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      color: 'text.secondary',
                    }}
                  >
                    <DescriptionIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                    <Typography variant="h6">
                      No se encontraron presupuestos
                    </Typography>
                    <Typography variant="body2">
                      {termp
                        ? 'Intenta con otros términos de búsqueda'
                        : 'Aún no hay presupuestos registrados'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 500,
          },
        }}
      />
      <Dialog
        open={openDialog}
        onClose={cerrarDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Alerta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Debe agregar un motivo del cierre.
          </DialogContentText>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Motivo de cierre"
            name="MOTIVODECIERRE"
            value={cierre.MOTIVODECIERRE}
            autoFocus
            margin="dense"
            onChange={cierreHandleChange}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={cerrarDialog} color="secondary">
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={() => cerrarPresupuesto('GANADO')}
            color="primary"
          >
            Ganado
          </Button>
          <Button
            variant="contained"
            onClick={() => cerrarPresupuesto('PERDIDO')}
            color="primary"
          >
            Perdido{' '}
          </Button>
        </DialogActions>
      </Dialog>
      


      <Dialog
  open={openDetalle}
  onClose={() => setOpenDetalle(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Detalle del Presupuesto</DialogTitle>

  <DialogContent dividers>
    {detallePresupuesto ? (
      <>
        <Typography variant="h6" gutterBottom>
          N° Comprobante: {detallePresupuesto.numerocomprobante}
        </Typography>
        <Typography>
          Cliente: {detallePresupuesto.cliente?.nombre}{' '}
          {detallePresupuesto.cliente?.apellido}
        </Typography>
        <Typography>
          Sucursal: {detallePresupuesto.nombresucursal}
        </Typography>
        <Typography>
          Moneda: {detallePresupuesto.moneda}
        </Typography>
        <Typography>
          Fecha: {detallePresupuesto.fechacomprobante?.substring(0, 10)}
        </Typography>
        <Typography gutterBottom>
          Total:{' '}
          {Intl.NumberFormat('es').format(detallePresupuesto.totalpresupuesto)}
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          Detalle de productos:
        </Typography>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Producto</TableCell>
              <TableCell align="right">Cantidad</TableCell>
              <TableCell align="right">Precio</TableCell>
              <TableCell align="right">Descuento</TableCell>
              <TableCell align="right">Subtotal</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {detallePresupuesto.detalles?.map((d, index) => {      
            const subtotal = (d.cantidad || 0) * (d.precioventabruto || 0);
            const desLinea = d.producto?.linea?.deslinea?.trim() || '';
            const desRubro = d.producto?.rubro?.desrubro?.trim() || '';
              return (
                <TableRow key={index}>
                  <TableCell>{d.producto?.desproducto}
                     {/* Línea (solo si existe) */}
          {desLinea && (
            <Typography variant="caption" color="textSecondary" display="block">
              Línea: {desLinea}
            </Typography>
          )}

          {/* Rubro (solo si existe) */}
          {desRubro && (
            <Typography variant="caption" color="textSecondary" display="block">
              Rubro: {desRubro}
            </Typography>
          )}
                  </TableCell>
                  
                  <TableCell align="right">{d.cantidad}</TableCell>
                  <TableCell align="right">
                    {Intl.NumberFormat('es').format(d.precioventabruto || 0)}
                  </TableCell>
                  <TableCell align="right">
                    {d.descuento ? d.descuento + '%' : '-'}
                  </TableCell>
                  <TableCell align="right">
                  {Intl.NumberFormat('es').format(subtotal)}
                </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <Typography align="right" sx={{ mt: 2, fontWeight: 'bold' }}>
          Total general: {Intl.NumberFormat('es').format(detallePresupuesto.totalpresupuesto)}
        </Typography>
      </>
    ) : (
      <Typography>Cargando datos...</Typography>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenDetalle(false)}>Cerrar</Button>
  </DialogActions>
</Dialog>

    </Box>
  );
}
